import moment from "moment";

export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };

  
export const columns = [
    // {
    //   field: "_id",
    //   header: "Id",
    //   accessor: (row, handleCellClick) => (
    //     <>
    //       <div onClick={() => handleCellClick(row, "_id")} className="">
    //         <p>{row?.unit_id}</p>
    //         <p className="w-full text-blue-500">
    //           {row?._id}
    //         </p>
    //       </div>
    //     </>
    //   ),
    // },
   
    {
      field: "packaging_name",
      header: "Packaging Name",
      accessor: (row) => (
        <>
          <div className="">
            <p>{row?.packaging_name}</p>
          </div>
        </>
      ),
    },
    {
      field: "packaging_type",
      header: "Packaging Type",
      accessor: (row) => (
        <>
          <div className="">{row?.packaging_type}</div>
        </>
      ),
    },
  ];